<template>
    <div>
        <a class="mdc-list-item d-flex justify-content-between align-items-center" @click="toggleSettingSelect()" :class="{ 'mdc-list-item-active':isSettingSelect}" >
             <span class="drawer-icon-size material-icons mdc-list-item__graphic">
                <img v-if="!isSettingSelect" src="images/icons/settings_inactive.svg" alt/>
                <img v-else src="images/icons/settings_active.svg" alt />
                    </span>
            <div class="flex-grow-1">
                {{$t('2050')}}
            </div>
            
            <!-- 언어선택 -->
            <i class="material-icons">
                {{!isSettingSelect ? 'expand_more' : 'expand_less' }}
            </i>
        </a>
        <transition name="slide">
            <div v-if="isSettingSelect">
                <drawer-language @closeDrawer="closeDrawer"></drawer-language>
                <!-- <a class="mdc-list-item">
                    <i class="material-icons mdc-list-item__graphic"></i>
                    {{ $t('2058') }}
                </a> -->
                <router-link class="mdc-list-item" to="/member/changepassword" style="color:#212121">
                    <i class="material-icons mdc-list-item__graphic"></i>
                    {{$t('2049')}}
                </router-link>
            </div>
        </transition>
    </div>
</template>

<script>
import TopAppBarDrawerLanguage from './TopAppBarDrawerLanguage.vue'
export default {
    data() {
        return {
            isSettingSelect: false
        }
    },
    components: {
        'drawer-language': TopAppBarDrawerLanguage, 
    },
    methods: {
        toggleSettingSelect() {
            this.isSettingSelect = !this.isSettingSelect
        },
        closeDrawer() {
            this.$emit('closeDrawer')
        },
    }
}
</script>
<style scoped>
.mdc-list-item {
  color: #212121 !important;
    text-decoration: none !important;
}
.mdc-list-item-active{
  color: #448aff !important;
}
</style>